<script setup lang="ts">
const { $containment } = useNuxtApp();

function onModalClose() {
  $containment.closeVerificationModal();
}

// Active or disable the verification debug
const activeVerificationDebug = ref(true);

const isVerificationDebugVisible = computed(() => {
  return $containment.isVerificationModalOpen && activeVerificationDebug.value;
});
</script>

<template>
  <BaseModal
    :custom-class-modal="$style.verificationOverlay"
    :custom-class-wrapper="$style.verificationModal"
    :model-value="$containment.isVerificationModalOpen"
    persistent
    @close="onModalClose"
  >
    <AuthVerification />
  </BaseModal>

  <DevOnly v-if="isVerificationDebugVisible">
    <AuthVerificationDebug />
  </DevOnly>
</template>

<style module lang="postcss">
.verificationModal {
  @apply p-0;
}

/* Bug real: com o mesmo z-index de Modal.vue (z-1000), a ordem final na
   tela depende da ordem de inserção no <body> pelo Teleport, não de quem
   abriu por último — em /user/account isso deixava esse modal (obrigatório)
   atrás do modal de "Cadastrar conta bancária". Verificação de segurança
   sempre tem que ganhar de qualquer modal de feature. */
.verificationOverlay {
  @apply z-[1100];
}
</style>
